import XssFilterUtility from "../utils/xssFilter";
import _ from "lodash";
import * as commonHelper from "@/components/services/common-helper";


const SCREEN_TYPE = { configurator: null, participantSubmittedResp: "response" };

export default class QlVideoUploadService {
  moduleName = null;
  studyID = null;
  clientID = null;
  responseLang = "EN"; // participant response lang. for survey & EPRO (to display to research site member)
  screenType = null; // for configurator, value == null | for participant response, value == "response"

  getModuleBasedSignedVideosUrl = null;

  videoStylesText = "";

  appLangaScript = "window.initApplanga = function() {        if(typeof window.ApplangaNative !== 'undefined') {  window.ApplangaNative.loadScript();        } else { setTimeout(window.initApplanga, 180); }    }; window.initApplanga();";

  appLangaScriptWithLessSpace = "window.initApplanga = function() { if(typeof window.ApplangaNative !== 'undefined') { window.ApplangaNative.loadScript(); } else { setTimeout(window.initApplanga, 180); } }; window.initApplanga();";

  manageParticipantVideoDisplayScript = null;

  manageParticipantVideoDisplayScriptWithScriptTags = null;

  mainFunctionCallScript = null;

  XssFilter = null;

  constructor(moduleName, studyId, clientid) {
    this.moduleName = moduleName;
    this.studyID = studyId;
    this.clientID = clientid;
    this.initUrl();
    this.initScript();
    this.XssFilter = new XssFilterUtility();
  }

  initUrl() {
    this.getModuleBasedSignedVideosUrl = `${process.env.VUE_APP_API_BASE_URL}/api/v1/studymanagement/studies/${this.studyID}/signedVideosUrl?moduleName=${this.moduleName}`;
  }

  initScript() {
    const url = window.location.href;
    const env = commonHelper.getEnvironmentFromHash(url);
    this.manageParticipantVideoDisplayScript = `function processVideos(iframes, parsedData) { let loaderDiv = document.getElementsByClassName("loaderDiv"); for ( let i = 0; i < iframes.length; i++ ) { let vidId = iframes[i].src && iframes[i].src.split("video/")[1]; let newId = vidId && vidId.split("/"); let videoId = newId && newId[0]; if ( videoId ) { iframes[i].src = parsedData[videoId]; } iframes[i].style.visibility = "visible"; if ( loaderDiv && loaderDiv.length && loaderDiv[i] ) loaderDiv[i].style.display = "none"; } }; function addLoader(iframes) { if (iframes && iframes.length) { for ( let i = 0; i < iframes.length; i++ ) { const el = document.createElement('div'); var x = document.createElement("IMG"); x.setAttribute("width", "50"); x.setAttribute("height", "50"); x.setAttribute("alt", "The Pulpit Rock"); x.setAttribute("src","@/assets/loader-large.gif"); el.appendChild(x); el.setAttribute("class","loaderDiv"); el.setAttribute("style", "border: none; width: 298px; height: 151px; position: absolute; left: 10px; text-align: center; color: #000; background-color: #fff;"); iframes[i].parentNode && iframes[i].parentNode.insertBefore(el, iframes[i]); } } }; function setS3SignedUrl( data ) { var iframes = document.getElementsByTagName("iframe"); let parsedData = JSON.parse(data); if ( iframes && iframes.length ) { processVideos(iframes, parsedData); } }; function getS3SignedUrl() { let theUrl = "${this.getModuleBasedSignedVideosUrl}"; var xmlHttp = new XMLHttpRequest(); xmlHttp.onreadystatechange = function() { if (xmlHttp.readyState == 4 && xmlHttp.status == 200) { setS3SignedUrl(xmlHttp.responseText); } }; xmlHttp.open("GET", theUrl, true); xmlHttp.setRequestHeader("clientid", ${this.clientID}); ${env === "test" ? 'xmlHttp.setRequestHeader("Env", "test");' : ''} xmlHttp.send(null); }; function loadData(){ let iframes = document.getElementsByTagName("iframe"); addLoader(iframes); for ( let i = 0; i < iframes.length; i++ ) { iframes[i].style.visibility = "hidden"; } getS3SignedUrl(); };`;

    this.manageParticipantVideoDisplayScriptWithScriptTags = `<script>${this.manageParticipantVideoDisplayScript}</script>`;

    this.mainFunctionCallScript = `<script> setTimeout(loadData(), 3000); </script>`;
  }

  emptyScriptFields() {
    this.manageParticipantVideoDisplayScript = "";
    this.manageParticipantVideoDisplayScriptWithScriptTags = "";
    this.mainFunctionCallScript = "";
  }

  replaceQuotes(inputStr, resultStr) {
    this.appLangaScript = this.appLangaScript.replaceAll(inputStr, resultStr);
    this.appLangaScriptWithLessSpace = this.appLangaScriptWithLessSpace.replaceAll(inputStr, resultStr);
    this.videoStylesText = this.videoStylesText.replaceAll(inputStr, resultStr);
    this.getModuleBasedSignedVideosUrl = this.getModuleBasedSignedVideosUrl.replaceAll(inputStr, resultStr);
    this.manageParticipantVideoDisplayScript = this.manageParticipantVideoDisplayScript.replaceAll(inputStr, resultStr);
    this.mainFunctionCallScript = this.mainFunctionCallScript.replaceAll(inputStr, resultStr);
    this.manageParticipantVideoDisplayScriptWithScriptTags = this.manageParticipantVideoDisplayScriptWithScriptTags.replaceAll(inputStr, resultStr);
  }

  replaceSignedVideoS3Url(screens, contentProp, participantVideos) {
    //Due to api auth. token expiration, 'participantVideos' becomes empty, this check will show old S3 url.
    if (_.isEmpty(participantVideos)) {
      /* this.$toastr.error("No participant Videos found"); */
      return;
    }
    for (let screen of screens) {
      if (this.moduleName === "survey") {
        // For survey & EPROs
        if (this.screenType === SCREEN_TYPE.configurator && !(screen.type === "SurveyInstruction" || screen.type === "GPSkin" || screen.type === "ImageCapture")) {
          continue;
        }
      }

      if (screen[contentProp] && screen[contentProp].indexOf("<iframe") > -1) {
        this.replaceSighedVideoS3UrlWithParticipantVideoUrl(screen, contentProp, participantVideos);
        // For Survey & EPROs at configurator & study-details
        if (this.moduleName === "survey" && this.screenType === SCREEN_TYPE.configurator) {
          screen["formattedInformation"] = screen["information"] ? screen["information"] : null;
        }
      }
    }
  }

  replaceSignedVideoS3UrlFforSingleScreen(screen, contentProp, participantVideos) {
    //Due to api auth. token expiration, 'participantVideos' becomes empty, this check will show old S3 url.

    if (screen[contentProp] && screen[contentProp].indexOf("<iframe") > -1) {
      this.replaceSighedVideoS3UrlWithParticipantVideoUrl(screen, contentProp, participantVideos);
    }
  }

  replaceSighedVideoS3UrlWithParticipantVideoUrl(screen, contentProp, participantVideos) {
    let iframes = screen[contentProp].split("<iframe");
    for (let i = 1; i < iframes.length; i++) {
      if (iframes[i].indexOf("study/" + this.studyID + "/video/") > -1) {
        let vidId = iframes[i].split("video/")[1];
        let newId = vidId && vidId.split("/");
        let videoId = newId && newId[0];
        let srcs = iframes[i].split('src="');
        let src = srcs[1];
        let vals = src.split('"');
        vals[0] = participantVideos[videoId];
        srcs[1] = vals.join('"');
        let updatedSrc = srcs.join('src="');
        iframes[i] = "<video controls" + updatedSrc.replace("iframe", "video");
        iframes[i] = iframes[i].replace('width="undefined"', 'width="300px"');
      } else {
        iframes[i] = "<iframe" + iframes[i];
      }
    }
    screen[contentProp] = iframes.join("");
  }

  getVideoIdsFromIframeTagIds(question) {
    let videoIds = [];
    if (question.formattedInformation) {
      let questionDomParser = new DOMParser();
      let formattedinformationNode = questionDomParser.parseFromString(question.formattedInformation, "text/html");
      let iframes = formattedinformationNode.getElementsByTagName("iframe");
      if (iframes && iframes.length > 0) {
        for (let i = 0; i < iframes.length; i++) {
          let src = iframes[i].src;
          let vals = src.split("?");
          let valArr = vals[0].split("/");
          let url = new URL(vals[0]);
          if (process.env.VUE_APP_API_ACTIVITY_BASE_URL && process.env.VUE_APP_API_ACTIVITY_BASE_URL.includes("//")) {
            url.hostname = process.env.VUE_APP_API_ACTIVITY_BASE_URL.split("//")[1];
            url.pathname = url.pathname.toString().split(".")[0];
          }
          iframes[i].src = url.toString();
          let lastElement = valArr.pop();
          let finalId = lastElement.toString().split(".")[0];
          videoIds.push(finalId);
        }
      }
      question.formattedInformation = formattedinformationNode.body.innerHTML;
    }
    return videoIds;
  }

  removeScriptAndStylesTexts(screens, contentProp) {
    if (screens && screens.length) {
      screens.forEach(screenOld => {
        let screen = screenOld;
        screen = this.removeScriptAndStylesFromSingleScrn(screen, contentProp);
        if (this.moduleName === "survey") {
          screen = this.removeUnnecessaryHtmlTagsForSingleScreenInSurvey(screen, contentProp);
        } else {
          screen = this.removeUnnecessaryHtmlTagsForSingleScreen(screen, contentProp);
        }
        return screen;
      });
    }
    return screens;
  }

  removeScriptAndStylesFromSingleScrn(screenOld, contentProp) {
    let screen = screenOld;
    if (screen && screen[contentProp]) {
      this.replaceQuotes("'", '"');
      screen[contentProp] = screen[contentProp] && screen[contentProp].replace(this.videoStylesText, "");
      screen[contentProp] = screen[contentProp] && screen[contentProp].replace(this.appLangaScript, "");
      screen[contentProp] = screen[contentProp] && screen[contentProp].replace(this.appLangaScriptWithLessSpace, "");
      screen[contentProp] = screen[contentProp] && screen[contentProp].replace(this.manageParticipantVideoDisplayScriptWithScriptTags, "");
      screen[contentProp] = screen[contentProp] && screen[contentProp].replace(this.manageParticipantVideoDisplayScript, "");
      screen[contentProp] = screen[contentProp] && screen[contentProp].replace(this.mainFunctionCallScript, "");

      if (this.moduleName === "survey") {
        screen = this.removeUnnecessaryHtmlTagsForSingleScreenInSurvey(screen, contentProp);
      } else {
        screen = this.removeUnnecessaryHtmlTagsForSingleScreen(screen, contentProp);
      }

      screen = this.removeHarmfulScriptfromScreen(screen, contentProp);
    }
    return screen;
  }

  insertDummyUrlToScreen(contentOld) {
    let content = contentOld;
    if (!content) {
      return;
    }

    if (content.indexOf("<iframe") > -1) {
      let updateUrl = `${process.env.VUE_APP_API_BASE_URL}/api/v1/studymanagement/${this.clientID}/study/${this.studyID}/video/`;
      let iframes = content.split("<iframe");
      for (let i = 1; i < iframes.length; i++) {
        if (iframes[i].indexOf("study/" + this.studyID + "/video/") > -1) {
          /* excludes links,eg. youtube links */
          let vidId = iframes[i].split("video/")[1];
          let newId = vidId && vidId.split("/");
          let videoId = newId && newId[0];
          let srcs = iframes[i].split('src="');
          let src = srcs[1];
          let vals = src.split('"');
          /* let url = vals[0]; */
          vals[0] = `${updateUrl}${videoId}/emptyvideourl`; /* inserting Dummy url */
          srcs[1] = vals.join('"');
          let updatedSrc = srcs.join('src="');
          iframes[i] = updatedSrc;
        }
      }
      content = iframes.join("<iframe");
    }
    return content;
  }

  removeUnnecessaryHtmlTagsForSingleScreen(screen, contentProp) {
    if (!screen[contentProp]) {
      return;
    }

    /* Removing <body tags*/
    if (screen[contentProp].indexOf("<body ") > -1) {
      let bodyContent = screen[contentProp].split("<body ");

      let scriptArr = null;

      let htmlCanContainBeginningScriptTag = null;

      let pureHtmlContent;
      if (bodyContent && bodyContent.length && bodyContent.length > 1) {
        let contentWithEndBodyTag = bodyContent[bodyContent.length - 1];
        let bodyInnerContent = contentWithEndBodyTag.split("</body>");
        let insideBodyContent = bodyInnerContent[0];
        let tempBody = `${insideBodyContent}`;
        if (tempBody.indexOf("</script>") > -1) {
          let t = tempBody.split("</script>");
          htmlCanContainBeginningScriptTag = t && t[1];
          pureHtmlContent = htmlCanContainBeginningScriptTag && htmlCanContainBeginningScriptTag.trim();
          if (htmlCanContainBeginningScriptTag && htmlCanContainBeginningScriptTag.indexOf("<script>") > -1) {
            scriptArr = htmlCanContainBeginningScriptTag.split("<script>");
            pureHtmlContent = scriptArr && scriptArr[0];
          }
        } else {
          if (tempBody.indexOf(">") > -1) {
            let index = tempBody.indexOf(">");
            tempBody = tempBody.substring(index + 1, tempBody.length);
          }
          pureHtmlContent = tempBody;
        }
      }
      screen[contentProp] = pureHtmlContent;
    }
    return screen;
  }

  removeUnnecessaryHtmlTagsForSingleScreenInSurvey(screen, contentProp) {
    if (!screen[contentProp]) {
      return;
    }

    /* Removing <body tags*/
    if (screen[contentProp].indexOf("</script>") > -1) {
      let scriptArr = null;

      let htmlCanContainBeginningScriptTag = null;

      let pureHtmlContent;
      let t = screen[contentProp].split("</script>");
      htmlCanContainBeginningScriptTag = t && t[1];
      pureHtmlContent = htmlCanContainBeginningScriptTag && htmlCanContainBeginningScriptTag.trim();
      if (htmlCanContainBeginningScriptTag && htmlCanContainBeginningScriptTag.indexOf("<script>") > -1) {
        scriptArr = htmlCanContainBeginningScriptTag.split("<script>");
        pureHtmlContent = scriptArr && scriptArr[0];
      }

      screen[contentProp] = pureHtmlContent;
    }
    return screen;
  }

  includeScriptOnlyIfVideosPresent(content) {
    if (!content) {
      return;
    }

    /* Video exists in manually added videos */
    if (content.indexOf("<iframe") > -1 && content.indexOf("study/" + this.studyID + "/video/") > -1) {
      this.initScript();
    } else {
      /* don't add script if, video doesn't exist */
      this.emptyScriptFields();
    }
  }

  removeHarmfulScriptfromMultipleScreens(screens, contentProp) {
    if (screens && screens.length) {
      screens.forEach(screenOld => {
        let screen = screenOld;
        screen = this.removeHarmfulScriptfromScreen(screen, contentProp);
        return screen;
      });
    }
    return screens;
  }

  removeHarmfulScriptfromScreen(screen, contentProp) {
    if (!screen[contentProp]) {
      return;
    }
    screen[contentProp] = this.XssFilter.stripeHarmfulScripts(screen[contentProp]);
    return screen;
  }
}
